import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'zah-clientnummer-input',
    templateUrl: './clientnummer-input.component.html',
    standalone: false
})
export class ClientnummerInputComponent {

  @Output()
  nummerInput: EventEmitter<string> = new EventEmitter<string>();

  nummer: string;

  onNummerInput(): void {
    this.nummerInput.emit(this.nummer);
  }
}
